import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import { StyledTableRow } from "../../../../../styles/Shipmentstyles";
import AppTableHeaderCell from "../../../../../views/components/common/pages/AppTableHeaderCell";
import AppTableRowCell from "../../../../../views/components/common/pages/AppTableRowCell";
import {
  DailyIncentive,
  OwnerSalesRow,
} from "../../../../../models/Dashboard/SalesDashboard/SalesAnalytics";
import { CurrencyHelper } from "../../../../../utils/CurrencyHelper";
import { formatDateWithoutTime } from "../../../../../views/components/common/functions/formatDate";

interface SalesIncentivesRowTableProps {
  data: DailyIncentive[];
}

const SalesIncentivesRowTable = ({ data }: SalesIncentivesRowTableProps) => {
  const theme = useTheme();

  return (
    <>
      <TableContainer style={{ height: "100%", maxHeight: "100%" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <AppTableHeaderCell
                minWidth="80px"
                title="S.No"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                minWidth="300px"
                title="OWNER"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="OUTBOUND INCENTIVE (₹)"
                minWidth="200px"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="INCENTIVE (₹)"
                minWidth="200px"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="SCORE"
                minWidth="200px"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="ACTUAL INCENTIVE (₹)"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
              <AppTableHeaderCell
                title="DATE"
                sx={{
                  backgroundColor:
                    theme.palette.customColors.lightGreyColor || "#f5f5f5",
                }}
              />
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item: DailyIncentive, index: number) => (
              <StyledTableRow key={item.owner_name}>
                <AppTableRowCell minWidth="80px">{index + 1}</AppTableRowCell>
                <AppTableRowCell minWidth="80px">
                  {item.owner_name}
                </AppTableRowCell>
                <AppTableRowCell minWidth="300px">
                  {item.outbound_incentive}
                </AppTableRowCell>

                <AppTableRowCell>{item.incentive ?? 0}</AppTableRowCell>

                <AppTableRowCell>
                  {CurrencyHelper.formatIndianNumber(item.score)}
                </AppTableRowCell>

                <AppTableRowCell>{item.total_incentive ?? 0}</AppTableRowCell>

                <AppTableRowCell>
                  {formatDateWithoutTime(item.date)}
                </AppTableRowCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SalesIncentivesRowTable;
